import { Modal, TModalProps } from '@/common/components/Modal/Modal';

export function Drawer(props: TModalProps) {
  return (
    <Modal
      name="drawer"
      {...props}
      horizontalPosition="right"
      height="stretch"
    />
  );
}
